var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoin2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 79,
    viewBox: "0 0 151 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131.408 -19.143C142.183 -0.938917 125.985 28.5758 95.2353 46.7799C64.4796 64.984 30.8157 64.9785 20.0408 46.7744C9.26598 28.5703 25.4583 -0.944384 56.214 -19.1485C86.9696 -37.3526 120.634 -37.3471 131.408 -19.143Z",
    fill: "url(#paint0_linear_502_8445)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131.934 -18.2519C142.709 -0.0478039 126.516 29.4669 95.7606 47.671C65.0049 65.8751 31.341 65.8696 20.5661 47.6655C9.79129 29.4614 25.9891 -0.0532703 56.7393 -18.2574C87.4949 -36.4615 121.159 -36.456 131.934 -18.2519Z",
    fill: "url(#paint1_linear_502_8445)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M132.196 -17.8037C143.119 0.646397 127.041 30.3634 96.2853 48.5675C65.5297 66.7716 31.7455 66.5638 20.8231 48.1137C9.9006 29.6636 25.9782 -0.0533428 56.7338 -18.2574C87.4894 -36.4615 121.274 -36.2593 132.196 -17.8037Z",
    fill: "url(#paint2_linear_502_8445)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M132.726 -16.9126C143.649 1.53751 127.571 31.2545 96.8156 49.4586C66.06 67.6627 32.2758 67.4604 21.3533 49.0048C10.4309 30.5493 26.5084 0.83777 57.2641 -17.3663C88.0197 -35.5704 121.804 -35.3682 132.721 -16.9126H132.726Z",
    fill: "url(#paint3_linear_502_8445)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M133.251 -16.0215C144.174 2.42862 128.096 32.1456 97.3404 50.3497C66.5848 68.5538 32.8006 68.3515 21.8836 49.896C10.9611 31.4404 27.0387 1.72888 57.7943 -16.4752C88.55 -34.6793 122.334 -34.4771 133.257 -16.0215H133.251Z",
    fill: "url(#paint4_linear_502_8445)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M133.782 -15.1304C144.704 3.31974 128.626 33.0367 97.8708 51.2408C67.1152 69.4449 33.331 69.2426 22.4085 50.7871C11.4861 32.337 27.5636 2.62 58.3192 -15.5841C89.0749 -33.7882 122.859 -33.5859 133.782 -15.1304Z",
    fill: "url(#paint5_linear_502_8445)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M134.306 -14.2395C145.228 4.21061 129.151 33.9276 98.3952 52.1317C67.6396 70.3358 33.8554 70.1335 22.9329 51.6779C12.0105 33.2278 28.088 3.51087 58.8437 -14.6932C89.5993 -32.8973 123.383 -32.6951 134.306 -14.2395Z",
    fill: "url(#paint6_linear_502_8445)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M134.837 -13.3484C145.759 5.10172 129.682 34.8187 98.926 53.0228C68.1703 71.2269 34.3861 71.0191 23.4637 52.569C12.5412 34.1189 28.6188 4.40198 59.3744 -13.8021C90.1301 -32.0062 123.914 -31.804 134.837 -13.3484Z",
    fill: "url(#paint7_linear_502_8445)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M135.361 -12.4573C146.284 5.99283 130.206 35.7098 99.4504 53.9139C68.6948 72.118 34.9106 71.9157 23.9881 53.4602C13.0656 35.0046 29.1432 5.29309 59.8988 -12.911C90.6545 -31.1151 124.439 -30.9128 135.356 -12.4573H135.361Z",
    fill: "url(#paint8_linear_502_8445)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M135.891 -11.5662C146.814 6.88395 130.736 36.6009 99.9807 54.805C69.225 73.0091 35.4408 72.8068 24.5184 54.3513C13.5959 35.8957 29.6735 6.18421 60.4291 -12.0199C91.1847 -30.224 124.969 -30.0217 135.891 -11.5662Z",
    fill: "url(#paint9_linear_502_8445)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M136.416 -10.675C147.339 7.77505 131.261 37.492 100.506 55.6961C69.7499 73.9002 35.9657 73.6925 25.0433 55.2424C14.1208 36.7923 30.1984 7.07532 60.954 -11.1288C91.7096 -29.3329 125.494 -29.1306 136.416 -10.675Z",
    fill: "url(#paint10_linear_502_8445)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7073 45.8872C125.462 27.6843 141.659 -1.83051 130.883 -20.036C120.108 -38.2416 86.4413 -38.2438 55.6865 -20.0409C24.9317 -1.8381 8.73511 27.6767 19.5104 45.8823C30.2857 64.0878 63.9525 64.09 94.7073 45.8872Z",
    fill: "#0C0232"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M123.356 -15.5788C132.677 0.165236 118.666 25.6947 92.0705 41.4333C65.475 57.1774 36.3539 57.172 27.0332 41.4279C17.7125 25.6838 31.7236 0.154303 58.3191 -15.5843C84.9146 -31.3284 114.036 -31.3229 123.356 -15.5788Z",
    fill: "#0C0232"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M123.356 -15.5788C132.677 0.165236 118.666 25.6947 92.0705 41.4333C65.475 57.1774 36.3539 57.172 27.0332 41.4279C17.7125 25.6838 31.7236 0.154303 58.3191 -15.5843C84.9146 -31.3284 114.036 -31.3229 123.356 -15.5788Z",
    fill: "url(#paint11_linear_502_8445)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.375 -19.1431C139.86 -1.43102 124.1 27.291 94.1806 44.9976C64.2559 62.7097 31.4994 62.7043 21.0143 44.9922C10.5292 27.2801 26.2897 -1.44196 56.2089 -19.1486C86.1336 -36.8607 118.89 -36.8552 129.375 -19.1431ZM92.0704 41.4333C118.666 25.6893 132.677 0.165249 123.356 -15.5843C114.036 -31.3284 84.92 -31.3339 58.3245 -15.5898C31.729 0.15432 17.7179 25.6783 27.0386 41.4224C36.3593 57.1665 65.4749 57.172 92.0704 41.4279V41.4333Z",
    fill: "url(#paint12_linear_502_8445)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3193 15.1988L77.1218 5.69811C76.9023 5.5248 76.8799 5.20469 77.0629 4.87133L81.0051 -2.16827C81.0889 -2.32013 81.037 -2.4609 80.8887 -2.48203L69.881 -3.8846C69.7327 -3.90572 69.5353 -3.79322 69.4515 -3.64136L62.2052 9.28747C62.017 9.61927 62.0446 9.94093 62.2641 10.1142L74.4617 19.6149C74.6812 19.7882 74.7036 20.1084 74.5206 20.4417L70.5784 27.4813C70.4946 27.6332 70.5465 27.774 70.6948 27.7951L81.7024 29.1976C81.8507 29.2188 82.0482 29.1063 82.132 28.9544L89.3782 16.0256C89.5665 15.6938 89.5388 15.3721 89.3193 15.1988Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2139 -0.274006L87.2063 -1.67658C87.058 -1.6977 86.8606 -1.5852 86.7767 -1.43334L83.4659 4.47668C83.3427 4.69667 83.3588 4.91232 83.5046 5.0296L91.5936 11.3298C91.727 11.4321 92.0081 11.3272 92.1193 11.1265L98.3287 0.0449488C98.4125 -0.106909 98.3605 -0.247684 98.2123 -0.268808L98.2139 -0.274006Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0723 20.2871L59.9833 13.9869C59.8499 13.8847 59.5688 13.9895 59.4576 14.1902L53.2483 25.2718C53.1644 25.4236 53.2164 25.5644 53.3647 25.5855L64.3723 26.9881C64.5206 27.0092 64.718 26.8967 64.8019 26.7448L68.1127 20.8348C68.2359 20.6148 68.2198 20.3992 68.074 20.2819L68.0723 20.2871Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3189 15.1987L77.1214 5.69806C76.9019 5.52475 76.8795 5.20463 77.0625 4.87127L81.0047 -2.16833C81.0885 -2.32018 81.0365 -2.46096 80.8883 -2.48208L69.8806 -3.88465C69.7323 -3.90578 69.5349 -3.79328 69.4511 -3.64142L62.2048 9.28741C62.0166 9.61921 62.0442 9.94088 62.2637 10.1142L74.4613 19.6149C74.6807 19.7882 74.7032 20.1083 74.5201 20.4417L70.578 27.4813C70.4942 27.6331 70.5461 27.7739 70.6944 27.795L81.702 29.1976C81.8503 29.2187 82.0478 29.1062 82.1316 28.9544L89.3778 16.0255C89.5661 15.6937 89.5384 15.3721 89.3189 15.1987Z",
    fill: "url(#paint13_linear_502_8445)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2134 -0.273993L87.2058 -1.67656C87.0575 -1.69769 86.8601 -1.58519 86.7762 -1.43333L83.4654 4.47669C83.3422 4.69668 83.3583 4.91234 83.5041 5.02961L91.5931 11.3299C91.7265 11.4321 92.0076 11.3273 92.1188 11.1265L98.3281 0.0449619C98.412 -0.106896 98.36 -0.247671 98.2117 -0.268795L98.2134 -0.273993Z",
    fill: "url(#paint14_linear_502_8445)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0716 20.287L59.9827 13.9867C59.8492 13.8845 59.5681 13.9893 59.4569 14.1901L53.2476 25.2716C53.1638 25.4235 53.2157 25.5643 53.364 25.5854L64.3716 26.9879C64.5199 27.0091 64.7174 26.8966 64.8012 26.7447L68.112 20.8347C68.2352 20.6147 68.2191 20.3991 68.0733 20.2818L68.0716 20.287Z",
    fill: "url(#paint15_linear_502_8445)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_502_8445",
    x1: 20.4727,
    y1: 48.573,
    x2: 133.562,
    y2: -22.5706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_502_8445",
    x1: 21.0254,
    y1: 49.4477,
    x2: 134.115,
    y2: -21.6959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_502_8445",
    x1: 21.2987,
    y1: 49.8849,
    x2: 134.388,
    y2: -21.2532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_502_8445",
    x1: 21.8508,
    y1: 50.7651,
    x2: 134.94,
    y2: -20.3785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_502_8445",
    x1: 22.4029,
    y1: 51.6398,
    x2: 135.493,
    y2: -19.5038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_502_8445",
    x1: 22.9552,
    y1: 52.5145,
    x2: 136.039,
    y2: -18.6291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_502_8445",
    x1: 23.5015,
    y1: 53.389,
    x2: 136.591,
    y2: -17.7546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_502_8445",
    x1: 24.0541,
    y1: 54.2692,
    x2: 137.144,
    y2: -16.8744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_502_8445",
    x1: 24.6058,
    y1: 55.1439,
    x2: 137.695,
    y2: -15.9997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_502_8445",
    x1: 25.158,
    y1: 56.0186,
    x2: 138.248,
    y2: -15.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_502_8445",
    x1: 25.7102,
    y1: 56.8933,
    x2: 138.794,
    y2: -14.2503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3A2484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C0232"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_502_8445",
    x1: 60.0849,
    y1: -50.9812,
    x2: 81.2793,
    y2: 38.6563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A2484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A2484",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_502_8445",
    x1: 25.5735,
    y1: -70.9182,
    x2: 112.407,
    y2: 75.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D189F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#9222FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF0CBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF536D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FF7BAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26BCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_502_8445",
    x1: 53.2169,
    y1: 12.6565,
    x2: 98.3589,
    y2: 12.6565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF536D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF536D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_502_8445",
    x1: 53.2169,
    y1: 12.6565,
    x2: 98.3589,
    y2: 12.6565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF536D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF536D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_502_8445",
    x1: 53.2169,
    y1: 12.6565,
    x2: 98.3589,
    y2: 12.6565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF536D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF536D",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin2);
export default __webpack_public_path__ + "static/media/coin2.69077141.svg";
export { ForwardRef as ReactComponent };